import { Box, Typography } from '@mui/material';

// Renders auto-deploy StackSet previews (from apiService.previewFactoryStackSets)
// as "name — N region(s) — via <OU>" lines. Shared by the Create Account modal
// and the onboarding confirm step so both read the same way.
const METRO = 'Metropolis, sans-serif';

export const formatStackSetPreview = (p) => {
  const n = Array.isArray(p?.regions) ? p.regions.length : 0;
  const via = p?.matchedOuName || p?.matchedOu;
  return `${p?.name || p?.stackSetId || 'StackSet'} — ${n} region${n === 1 ? '' : 's'}${via ? ` — via ${via}` : ''}`;
};

export default function StackSetsPreviewList({ items, dense = false }) {
  if (!Array.isArray(items) || items.length === 0) return null;
  return (
    <Box component="ul" sx={{ m: 0, mt: dense ? 0.25 : 0.75, pl: 2.5 }}>
      {items.map((p) => (
        <Typography
          component="li"
          key={p.stackSetId || p.name}
          title={Array.isArray(p.regions) ? p.regions.join(', ') : undefined}
          sx={{ fontFamily: METRO, fontSize: dense ? '0.78rem' : '0.85rem', color: '#333333', lineHeight: 1.5 }}
        >
          {formatStackSetPreview(p)}
        </Typography>
      ))}
    </Box>
  );
}
